import src from "IMAGE";
export default { src, width: 605, height: 136, blurWidth: 0, blurHeight: 0};
